import { createSelector } from "reselect"
import IState from "../state"
import { getCurrentUser } from "../currentUser/currentUser.selectors"

const selectAuthorizationState = (state: IState) => state.authorization

export const loading = (state: IState): boolean => state.authorization.loading
export const dispatched = (state: IState): boolean => state.authorization.dispatched
export const authorized = (state: IState): boolean => state.authorization.authorized

export const getCurrentToken = createSelector(selectAuthorizationState, state => state.currentToken)

export const getUserId = (state: IState): string | undefined | null =>
  state.authorization.currentToken && state.authorization.currentToken.id
export const errors = (state: IState): object => state.authorization.errors

export const getAccessRoles = createSelector(getCurrentUser, getCurrentToken, (currentUser, currentToken) => {
  const userRoles = currentUser?.roles || []
  const userSystemRoles = currentToken?.system_roles || []
  return [...userRoles, ...userSystemRoles]
})
